import React from "react";
import { Input } from "components/bootstrap";
import WatchlistSelector from "../watchlist/WatchlistSelector";
const WatchlistQueryParameterEdit = ({ parameter, onChange, identifier, validationState = void 0 }) => {
  var _a, _b, _c, _d;
  return /* @__PURE__ */ React.createElement(
    Input,
    {
      id: `watchlist-query-parameter-${identifier}`,
      name: "watchlistId",
      label: "Watchlist",
      bsStyle: (_a = validationState == null ? void 0 : validationState.watchlistId) == null ? void 0 : _a[0],
      help: (_c = (_b = validationState == null ? void 0 : validationState.watchlistId) == null ? void 0 : _b[1]) != null ? _c : "Select the watchlist whose entries will be expanded into the query."
    },
    /* @__PURE__ */ React.createElement(
      WatchlistSelector,
      {
        id: `watchlist-query-selector-${identifier}`,
        value: (_d = parameter.watchlistId) != null ? _d : "",
        onChange: (id) => onChange("watchlistId", id)
      }
    )
  );
};
export default WatchlistQueryParameterEdit;
